import { call, put, takeEvery } from 'redux-saga/effects';
import {
  ActionGetAllMedicalHistorySuccess,
  ActionGetMedicalDraftSuccess,
  ActionGetMedicalDraftFailure,
} from '../Actions/MedicalHistoryAction';
import { GET_ALL_MEDICAL_HISTORY, GET_MEDICAL_DRAFT } from '../storeTypes';
import { GetMedicalHistoryDetailsApi, GetMedicalDraftApi } from '../../utils/api';
import { handleApiResponse } from '../../utils/functions';

const File = 'MedicalHistorySaga';

function* GetAllMedicalHistoryDetailsSaga(action) {
  try {
    const response = yield call(GetMedicalHistoryDetailsApi, action.payload);
    if (response?.status === 200) {
      yield put(ActionGetAllMedicalHistorySuccess(response?.data?.data[0]));
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callback);
}
}

function* GetMedicalDraftSaga(action) {
  try {
    const response = yield call(GetMedicalDraftApi, action.payload);
    if (response?.status === 200 && response?.data?.statusCode === 200) {
      yield put(ActionGetMedicalDraftSuccess(response?.data?.data));
    } else {
      yield put(ActionGetMedicalDraftFailure());
      // if (response?.data?.statusCode === 404) {
      //   handleApiResponse(404, response?.data, action?.payload?.callback, false, false);
      // }
    }
  } catch (error) {
    yield put(ActionGetMedicalDraftFailure());
    // handleApiResponse(error?.response?.status, error?.response?.data, action?.payload?.callback);
}
}

export function* MedicalHistorySaga() {
  yield takeEvery(GET_ALL_MEDICAL_HISTORY, GetAllMedicalHistoryDetailsSaga);
  yield takeEvery(GET_MEDICAL_DRAFT, GetMedicalDraftSaga);
}
